import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "regulations"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "field checkbox" };
const _hoisted_4 = ["name", "onUpdate:modelValue", "required"];
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("span", null, null, -1);
const _hoisted_6 = {
    key: 0,
    class: "regulation-title"
};
const _hoisted_7 = { key: 0 };
const _hoisted_8 = ["data-open", "data-title"];
const _hoisted_9 = {
    key: 1,
    class: "regulation-title"
};
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { class: "valid-messages" };
const _hoisted_12 = {
    key: 0,
    class: "error"
};
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--alert-alt" }, null, -1);
const _hoisted_14 = {
    key: 0,
    class: "regulation-desc"
};
const _hoisted_15 = { class: "field" };
const _hoisted_16 = { class: "form-control-static" };
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = ["id", "innerHTML"];
import { computed, onMounted } from "vue";
import { __ } from '../../js/helpers/i18n';
import { revealModal } from '../../js/functions/modal';
export default /*#__PURE__*/ _defineComponent({
    props: {
        regulations: {
            type: String,
            default: ""
        },
        b2bCheck: {
            type: Boolean,
            default: false,
        }
    },
    setup(__props) {
        const props = __props;
        const regulations = computed(() => {
            return JSON.parse(props.regulations);
        });
        onMounted(() => {
            revealModal();
        });
        const isValid = () => {
            let result = true;
            for (const i in regulations.value) {
                if (regulations.value[i].required && !regulations.value[i].checked) {
                    result = false;
                    regulations.value[i].not_valid = true;
                }
                else {
                    regulations.value[i].not_valid = false;
                }
            }
            return result;
        };
        const getData = () => {
            const data = {};
            for (const i in regulations.value) {
                const regulation = regulations.value[i];
                if (regulation.checked) {
                    data[regulation.id] = 1;
                }
            }
            return data;
        };
        return (_ctx, _cache) => {
            return (_unref(regulations).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(regulations), (regulation, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            class: "regulation",
                            key: index
                        }, [
                            (!regulation.is_b2b || (regulation.is_b2b && __props.b2bCheck))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "checkbox",
                                                name: regulation.field_name,
                                                value: "1",
                                                "onUpdate:modelValue": ($event) => ((regulation.checked) = $event),
                                                required: regulation.required
                                            }, null, 8, _hoisted_4), [
                                                [_vModelCheckbox, regulation.checked]
                                            ]),
                                            _hoisted_5,
                                            (regulation.content && regulation.content.length > 0)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                                    _createElementVNode("span", null, [
                                                        (regulation.required)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "* "))
                                                            : _createCommentVNode("", true),
                                                        _createTextVNode(_toDisplayString(regulation.title), 1)
                                                    ]),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "link-btn",
                                                        "data-open": 'regulation-' + regulation.id,
                                                        "data-title": regulation.title,
                                                        "data-icon": "icon--help-alt",
                                                        "data-class": "regulations-modal"
                                                    }, _toDisplayString(_unref(__)('zobacz więcej')), 9, _hoisted_8)
                                                ]))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                                    (regulation.required)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "* "))
                                                        : _createCommentVNode("", true),
                                                    _createTextVNode(_toDisplayString(regulation.title), 1)
                                                ]))
                                        ]),
                                        _createElementVNode("div", _hoisted_11, [
                                            (regulation.not_valid)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                    _hoisted_13,
                                                    _createElementVNode("span", null, _toDisplayString(_unref(__)('Zgoda jest wymagana')), 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    (regulation.description && regulation.description.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                            _createElementVNode("div", _hoisted_15, [
                                                _createElementVNode("p", _hoisted_16, [
                                                    _createElementVNode("small", {
                                                        innerHTML: regulation.description
                                                    }, null, 8, _hoisted_17)
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (regulation.content && regulation.content.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: "e-modal-reveal",
                                            id: 'regulation-' + regulation.id,
                                            innerHTML: regulation.content
                                        }, null, 8, _hoisted_18))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ]));
                    }), 128))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
